var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"google-maps-page"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"flex md12 xs12"},[_c('va-card',{staticClass:"google-maps-page__widget",attrs:{"title":_vm.$t('generic.checkRoute')}},[_c('google-map')],1)],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }